/**
 * Fireworks for a five-star review — the old hosted form's `thankYouConfetti`,
 * brought across as it was: bursts from either side of the screen every
 * quarter second for fifteen seconds, thinning out as they go.
 *
 * Loaded only when somebody earns it, so the form page itself does not carry
 * the library. `disableForReducedMotion` leaves out anyone who has asked
 * their device for less movement.
 */
const DURATION_MS = 15_000;

export async function celebrateFiveStars(): Promise<void> {
  if (typeof window === 'undefined') return;
  const { default: confetti } = await import('canvas-confetti');

  const end = Date.now() + DURATION_MS;
  const defaults = {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    // Above the form: the canvas never takes clicks, so the thank-you
    // screen's button stays usable underneath it.
    zIndex: 100,
    disableForReducedMotion: true,
  };
  const between = (min: number, max: number) => Math.random() * (max - min) + min;

  const timer = window.setInterval(() => {
    const left = end - Date.now();
    if (left <= 0) {
      window.clearInterval(timer);
      return;
    }
    const particleCount = 50 * (left / DURATION_MS);
    // Particles fall, so each burst starts a little above a random height.
    void confetti({ ...defaults, particleCount, origin: { x: between(0.1, 0.3), y: Math.random() - 0.2 } });
    void confetti({ ...defaults, particleCount, origin: { x: between(0.7, 0.9), y: Math.random() - 0.2 } });
  }, 250);
}

/**
 * Sites that asked the old app for no confetti. Kept so the move to the new
 * form does not bring back something a customer turned off.
 */
export const NO_CONFETTI_SITES = ['64498bb0bca2620f6d3c727c'];
